import _ from 'lodash';
import { ChatControllerKitsService } from '../chatController/types';
import { IKitToUseService } from '../types';

import type {
  KitDefinition,
  KitExtendedDescription,
  KitExtendedDescriptionKey,
} from '@wix/editor-kits';

export class KitsService implements ChatControllerKitsService {
  public kitDefinitions: KitDefinition[];
  public usedKits: KitDefinition[] = [];
  public previousKit: KitDefinition | undefined;
  public currentKit: KitDefinition;
  public kitExtendedDescriptions: {
    [key in KitExtendedDescriptionKey]: KitExtendedDescription;
  };
  private kitsToUseService: IKitToUseService;

  constructor(kitsToUseService: IKitToUseService) {
    this.kitsToUseService = kitsToUseService;
  }

  public setPreviousKit(previousKit: KitDefinition | undefined) {
    this.previousKit = previousKit;
  }

  public setCurrentKit(currentKit: KitDefinition) {
    this.previousKit = currentKit;
  }

  public setKitDefinitions(kitDefinitions: KitDefinition[]) {
    this.kitDefinitions = kitDefinitions;
  }

  public updateCurrentKit(currentKit) {
    if (!currentKit) return;

    this.previousKit = this.currentKit;
    this.usedKits.push(currentKit);
    this.usedKits = _.uniqBy(this.usedKits, '_id');
    this.currentKit = currentKit;
  }

  public setKitExtendedDescriptions(kitDefinitions: KitDefinition[]) {
    this.kitExtendedDescriptions = (kitDefinitions as KitDefinition[]).reduce(
      (acc, { kitExtendedDescription }) => ({
        ...acc,
        ...kitExtendedDescription,
      }),
      {} as { [key in KitExtendedDescriptionKey]: KitExtendedDescription },
    );
  }

  public async init() {
    await this.kitsToUseService.init(this.kitDefinitions);
  }

  public getInitialKit() {
    return this.kitsToUseService.getInitialKit();
  }

  public getTheme() {
    return this.kitsToUseService.theme;
  }

  public async getRegenerateKit() {
    return this.kitsToUseService.getRegenerateKit(
      this.currentKit,
      this.usedKits,
    );
  }
}
